import Layout from '@/layout'

// 合同管理路由
const contractsRoutes = {
  path: '/contracts',
  component: Layout,
  redirect: '/contracts/list',
  name: 'Contracts',
  meta: { title: '合同管理', icon: 'el-icon-tickets', requiresAuth: true },
  children: [
    // 新的统一合同页面
    {
      path: 'list',
      name: 'ContractsList',
      component: () => import('@/views/contracts/contracts-list'),
      meta: { title: '合同列表', requiresAuth: true }
    },
    {
      path: 'create',
      name: 'ContractCreate',
      component: () => import('@/views/contracts/contract-create'),
      meta: { title: '新增合同', requiresAuth: true },
      hidden: true
    },
    {
      path: 'edit/:id',
      name: 'ContractEdit',
      component: () => import('@/views/contracts/contract-create'),
      meta: { title: '编辑合同', requiresAuth: true },
      hidden: true
    },
    {
      path: 'view/:id',
      name: 'ContractView',
      component: () => import('@/views/contracts/contract-view'),
      meta: { title: '查看合同', requiresAuth: true },
      hidden: true
    },
    // 原有的采购合同相关路由
    {
      path: 'supplier-contracts-list',
      name: 'SupplierContractsList',
      component: () => import('@/views/contracts/supplier-contracts-list'),
      meta: { title: '采购合同列表', requiresAuth: true }
    },
    {
      path: 'supplier-contract-edit',
      name: 'SupplierContractEdit',
      component: () => import('@/views/contracts/supplier-contract-edit'),
      meta: { title: '新增采购合同', requiresAuth: true },
      hidden: true
    },
    {
      path: 'supplier-contract-edit/:id',
      name: 'SupplierContractEditById',
      component: () => import('@/views/contracts/supplier-contract-edit'),
      meta: { title: '编辑采购合同', requiresAuth: true },
      hidden: true
    },
    {
      path: 'supplier-contract-confirm/:id',
      name: 'SupplierContractConfirm',
      component: () => import('@/views/contracts/supplier-contract-confirm'),
      meta: { title: '查看采购合同', requiresAuth: true },
      hidden: true
    },
    {
      path: 'supplier/preview/:id',
      name: 'SupplierContractPreview',
      component: () => import('@/views/contracts/supplier-contract-preview'),
      meta: { title: '采购合同预览', requiresAuth: true },
      hidden: true
    },
    // 原有的销售合同相关路由
    {
      path: 'customer-contracts-list',
      name: 'CustomerContractsList',
      component: () => import('@/views/contracts/customer-contracts-list'),
      meta: { title: '销售合同列表', requiresAuth: true }
    },
    {
      path: 'customer-contract-edit',
      name: 'CustomerContractEdit',
      component: () => import('@/views/contracts/customer-contract-edit'),
      meta: { title: '新增销售合同', requiresAuth: true },
      hidden: true
    },
    {
      path: 'customer-contract-edit/:id',
      name: 'CustomerContractEditById',
      component: () => import('@/views/contracts/customer-contract-edit'),
      meta: { title: '编辑销售合同', requiresAuth: true },
      hidden: true
    },
    {
      path: 'customer-contract-confirm/:id',
      name: 'CustomerContractConfirm',
      component: () => import('@/views/contracts/customer-contract-confirm'),
      meta: { title: '查看销售合同', requiresAuth: true },
      hidden: true
    },
    {
      path: 'customer/view/:id',
      name: 'CustomerContractPreview',
      component: () => import('@/views/contracts/customer-contract-preview'),
      meta: { title: '销售合同预览', requiresAuth: true },
      hidden: true
    }
  ]
}

export default contractsRoutes 